import {
  FileUploadTask,
  UploadElementType,
} from "@custom-types/file-upload-types";
import { GUID } from "@faro-lotv/foundation";
import {
  isTaskCompleted,
  isTaskInProgress,
} from "@hooks/upload-tasks/upload-tasks-utils";
import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "@store/store-helper";
import { uploadTasksAdapter } from "@store/upload-tasks/upload-tasks-slice";

/** @returns List of all upload tasks */
export const uploadTasksSelector: (state: RootState) => FileUploadTask[] =
  createSelector(
    (state: RootState) => state.uploadTasks,
    (uploadTasks) => {
      const tasks = uploadTasksAdapter.getSelectors().selectAll(uploadTasks);

      return tasks;
    }
  );

/** @returns  An upload task */
export function uploadTaskByIdSelector(
  id: GUID
): (state: RootState) => FileUploadTask | undefined {
  return createSelector(
    (state: RootState) => state.uploadTasks,
    (uploadTasks) => {
      const uploadTask = uploadTasksAdapter
        .getSelectors()
        .selectById(uploadTasks, id);

      return uploadTask;
    }
  );
}

/** @returns List of all incomplete upload tasks */
const incompleteUploadTasksSelector: (state: RootState) => FileUploadTask[] =
  createSelector(uploadTasksSelector, (tasks) => {
    const incompleteUploadTasks = tasks.filter(
      (task) => !isTaskCompleted(task)
    );

    return incompleteUploadTasks;
  });

/** @returns True if any incomplete tasks is available in the store */
export const hasIncompleteUploadTasksSelector: (state: RootState) => boolean =
  createSelector(incompleteUploadTasksSelector, (incompleteUploadTasks) => {
    return !!incompleteUploadTasks.length;
  });

/** @returns True if any in-progress tasks is available in the store */
export const hasInProgressUploadTasksSelector: (state: RootState) => boolean =
  createSelector(uploadTasksSelector, (tasks) => {
    return tasks.some(isTaskInProgress);
  });

/** @returns List of incomplete attachment upload tasks for a given markup */
export function incompleteMarkupAttachmentUploadTasksSelector(
  iElementId: GUID
): (state: RootState) => FileUploadTask[] {
  return createSelector(incompleteUploadTasksSelector, (incompleteTasks) => {
    const markupAttachmentUploadTasks = incompleteTasks.filter(
      (task) =>
        task.context.uploadElementType === UploadElementType.annotation &&
        task.context.iElementId === iElementId
    );

    return markupAttachmentUploadTasks;
  });
}
